import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-ai-prompt',
  templateUrl: './ai-prompt.component.html',
  styleUrls: ['./ai-prompt.component.scss']
})
export class AiPromptComponent {
  @Input() value = '';
  @Input() labelKey = 'AI_CHAT.OVERVIEW_LABEL';
  @Input() placeholderKey = 'AI_CHAT.OVERVIEW_PLACEHOLDER';
  @Output() valueChange = new EventEmitter<string>();
  @Output() submitted = new EventEmitter<string>();

  public onValueChange(value: string): void {
    this.value = value;
    this.valueChange.emit(value);
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' && !event.shiftKey && !event.isComposing) {
      event.preventDefault();
      this.submit();
    }
  }

  public submit(): void {
    const value = (this.value || '').trim();
    if (value) {
      this.submitted.emit(value);
    }
  }
}
